import { useParams } from "react-router-dom"
import { Container, Row, Col } from "react-bootstrap"
import { useGetNotificationEntryByIdQuery } from "../../../services/bClientApi"
import NotificationEntry from "../../../Components/NotificationEntry/NotificationEntry"

export default function NotificationEntryPage() {
    const { notificationEntryId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetNotificationEntryByIdQuery(notificationEntryId, { skip: !notificationEntryId })
    const notificationEntryData = data || {}

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Single Notification Entry Page</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    {notificationEntryId && notificationEntryData && notificationEntryData._id && !isLoading && (
                        <div className="notificationinfo">
                            {/* <pre>
                                {JSON.stringify(notificationEntryData, null, 2)}            
                            </pre> */}
                            <NotificationEntry
                                notificationData={notificationEntryData}
                                fullView={true}
                            />
                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
